import { render, staticRenderFns } from "./distributoriAssociatiProdotti.vue?vue&type=template&id=6d6dd8e6&"
import script from "./distributoriAssociatiProdotti.vue.ts?vue&type=script&lang=ts&"
export * from "./distributoriAssociatiProdotti.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports